import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { languageSelectorItemType } from './LanguageSelectorTypes';


export default /*@__PURE__*/_defineComponent({
  __name: 'LanguageSelectorItem',
  props: {
    dataItem: { default: null },
    justifyContent: { default: 'left' },
    focused: { type: Boolean },
    selected: { type: Boolean }
  },
  setup(__props: any) {

const props = __props;

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("li", {
    class: "k-item",
    style: _normalizeStyle({ justifyContent: props.dataItem?.justify })
  }, _toDisplayString(props.dataItem?.text), 5))
}
}

})